import { Component, Input, OnInit } from '@angular/core';
import { MenuItem, MessageService } from "primeng/api";
import { Rol } from 'src/app/interfaces/rol.interface';
import { SendUpdateSuscription, UpdateSuscription } from 'src/app/interfaces/suscription.interface';
import { User } from 'src/app/interfaces/user.interface';
import { LoginService } from 'src/app/service/login.service';
import { UsersService } from 'src/app/service/users.service';
import { UserData } from 'src/app/interfaces/usersData';
import { forkJoin } from 'rxjs';
import { MessagesService } from 'src/app/service/messages.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-show-users',
  templateUrl: './show-users.component.html',
  styleUrls: ['./show-users.component.scss'],
  providers: [MessageService]
})
export class ShowUsersComponent implements OnInit {
  statusOriginal: any
  idsSuscriptionChange: any
  users: UserData[] = [];
  statuses: any[] = [];
  items: MenuItem[] = [];
  chatIds: any [] = []
  loading: boolean = true;
  selectedUserId: any;
  statusModal: boolean = false;
  roleModal: boolean = false;
  usersModal: boolean = false;
  currentStatus: string = "";
  currentRole: string | undefined;
  loadingApi: boolean = false

  public stat: string | undefined;
  rol!: Rol;
  public role: string = "";

  selectedDepart!: number[];
  suscriptionsSelected: UpdateSuscription[]=[];
  idUser!: any;
  actualizarSuscription!: SendUpdateSuscription;
  correo: string = "";
  idSuscription!: any;

  @Input() suscriptions!: UpdateSuscription[]
  @Input() roles!: Rol[];

  constructor(
    private userService: UsersService,
    private messageService: MessageService,
    private loginservice: LoginService, private message: MessagesService,
    private route: ActivatedRoute,
    public translate: TranslateService
  ) {
    this.userService.eventoUsuarioCreado().subscribe(v => {
      this.cargarUsuarios();
      // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
    })
   }

  ngOnInit(): void {
    this.correo = this.loginservice.chatCrmUser.email;
    this.cargarUsuarios();
    // this.message.dispositivo$().subscribe(data => {
    //   this.idSuscription = data == null ? null : data.id;
    //   if (this.idSuscription != null) {
    //     this.obtenerCatalogoUsuariosDispositivo(this.idSuscription);
    //   }
    // });
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }


dropdownOptions: any[] = [];

cargarUsuarios() {
  this.userService.usuariosXcliente(this.loginservice.chatCrmUser.idCustomer).then(
    result => {
      const listaUsuarios: any[] = result.data;

      // Conservar todos los usuarios en una lista
      this.users = listaUsuarios.filter(u => this.correo !== u.email);

      // Filtrar y crear opciones para el dropdown (name + lastName)
      this.dropdownOptions = listaUsuarios
        .filter(u => this.correo !== u.email)
        .map(u => ({ label: `${u.name} ${u.lastName}`, value: u.idUser, disabled: !u.status }));

      this.loading = false;
    }
  );
}

  obtenerValorSeleccionado(rol: Rol) {
    this.userService.actualizarRolUsuario(this.idUser, rol.id).then(
      result => {
        this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), detail: this.translate.instant('ROL_UPDATED') });
        this.roleModal = false;
        this.cargarUsuarios();
      }
    )
  }

  private obtenerCatalogoUsuariosDispositivo(idDispositivo: number) {
    this.userService.catalogoUsuarios(idDispositivo, this.loginservice.chatCrmUser.id).then(data => {
      const arrayModificado = data.data.map((objeto: { name: string, icon: string, id: number }) => {
        return {
          label: objeto.name,
          icon: "pi pi-user",
          idUser: objeto.id
        };
      });
      this.users = arrayModificado;
    });
  }

  openStatusModel(user: User) {
    this.statusModal = true;
    this.idUser = user.idUser;
    if (user.idsSubscriptions) {
      let coincidencia: UpdateSuscription[] = [];
      for (let index = 0; index < user.idsSubscriptions.length; index++) {
        for (const item of this.suscriptions) {
          if (item.id === user.idsSubscriptions[index]) {
            coincidencia.push(item)
          }
        }
      }
      this.suscriptionsSelected = coincidencia;

    }


  }

  openRoleModel(user: User) {
    this.roleModal = true;
    this.currentRole = user.rol;
    this.idUser = user.idUser;
    this.rol = {
      id: 0,
      name: ""
    }
  }

  nameToken: any
  idSubscriptions: any [] = []
  openUsersModal(idUser: any) {
    if(this.lenghtChats !== 0){
      this.usersModal = true;
      this.selectedUserId = idUser
      // this.idSubscriptions = user.idSubscriptions
      this.catalogosUsers = this.chatIds[this.lenghtChats - 1].catalogsUser
      this.nameToken = this.chatIds[this.lenghtChats - 1].nameToken
      return true;
    }
    return false;
  }

  userGuardado: any [] = []
  idUserGuardado: any;
  catalogosUsers: any [] = [];
  
  
  lenghtChats!: number;
  cambiarStatus(idUser: number, user: any) {
    this.statusOriginal = user.status;
    this.userService.actualizarStatusUsuario(idUser)
    .then(result => {
        if(result.data !== null){
          this.messageService.add({ severity: 'error', summary: 'Error',
           detail: 'No se pudo actualizar el estado porque el usuario tiene chats asignados.' });
           user.status = true
           this.chatIds = result.data
           this.userGuardado = user;
           this.idUserGuardado = user.idUser
          this.lenghtChats = result.data.length
          this.openUsersModal(user.idUser)
        }else{
          this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), 
          detail: this.translate.instant('STATUS_UPDATED_ACCOUNT') });
          this.cargarUsuarios()
        }

      }
    ).catch(error => {
      const response = error.error;
      if (response) {
        if (response.value == 3) {
          this.messageService.add({ severity: 'warn', summary: 'Advertencia', 
          detail: response.message});
          user.status = false;
        }
      } else {
        this.messageService.add({
          severity: 'error', summary: 'Error',
          detail: 'No se pudo actualizar el estado.'
        });
      }
    });
  }

  reasignarChats() {
    this.loadingApi = true
    const idUser = this.selectedUserId; // El usuario seleccionado
     const chats = this.chatIds[this.lenghtChats - 1]
     const body = chats.chatsIds
     this.userService.changeUserMultiple(chats.id, idUser, body).subscribe(
      results => {
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Se asignaron correctamente los chats al usuario' });
        this.usersModal = false;
        this.lenghtChats = this.lenghtChats - 1
        this.selectedUserId = null
        this.loadingApi = false
        if(!this.openUsersModal(this.selectedUserId) && !this.seAbrioDesdeSuscripcion){
          this.cambiarStatus(this.idUserGuardado, this.userGuardado)
        }
        if(this.seAbrioDesdeSuscripcion && !this.openUsersModal(this.actualizarSuscription.idUser)){
          this.actualizarSuscripcion()
        }
      },
      error => {
        // Manejo de errores si alguna de las solicitudes falla
        console.error('Error al asignar chats:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No se pudieron asignar los chats al usuario' });
        this.usersModal = false;
        this.loadingApi = false
      }
    );
  }
  
  
  seAbrioDesdeSuscripcion: boolean = false
  actualizarSuscripcion() {
    this.loadingApi = true
    let ids = [];
    for (const suscripcion of this.suscriptionsSelected) {
      ids.push(suscripcion.id)
    }
  
    this.actualizarSuscription = {
      idUser: this.idUser,
      idsSuscriptions: ids
    }
  
    this.userService.actualizarSuscripcion(this.actualizarSuscription).then(
      result => {
        if(result.data && result.data.length > 0){
          this.messageService.add({ severity: 'error', summary: 'Error',
           detail: this.translate.instant('ERROR_CHATS') });
           this.chatIds = result.data
            this.lenghtChats = result.data.length
            this.seAbrioDesdeSuscripcion = true
           this.openUsersModal(this.actualizarSuscription.idUser)
        }else{
          this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), detail: this.translate.instant('SELECTED_DEVICES_SUCCESS') });
          
        }
        this.cargarUsuarios();
        this.loadingApi = false
      }
    ).catch(
      error => {
        console.error('Error al actualizar la suscripción:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_UPDATE_SUSCRIPTION') });
        this.loadingApi = false
      }
    );
  }
  


}
